import { TableState } from '@portals/types';

import { PurchasedProductType } from './purchased-products.types';

export const PURCHASED_PRODUCTS_API_URL = 'ui/organization/purchased_products';

export const purchasedProductsQueryKeys = {
  base: [PURCHASED_PRODUCTS_API_URL],
  list: (
    tableState: Pick<TableState<PurchasedProductType>, 'sortBy' | 'filters'>
  ) => [...purchasedProductsQueryKeys.base, 'list', tableState],
  detail: (productId: string) => [
    ...purchasedProductsQueryKeys.base,
    productId,
  ],
};
